import { ColumnsType } from 'antd/es/table';
import { EditFilled } from '@ant-design/icons';
import dayjs from 'dayjs';
import { Button, Progress } from 'antd';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { Typography } from 'antd';
import { AnnualReviewCycle } from '../../../types/AnnualReview';
import { convertNameToPath, statusArray } from '../../../helper';
import { Status } from '../../../components';
import { Paths } from '../../../routes';
import { useAtom } from 'jotai';
import { useNavigate } from 'react-router-dom';
import { userAtom } from '../../../store/atom';

const { Text } = Typography;

dayjs.extend(quarterOfYear);

export const Columns = (
  onEditClick: (data: AnnualReviewCycle) => void
): ColumnsType => [
  {
    title: 'Name of Annual Review Cycle',
    key: 'name',
    sorter: (a: AnnualReviewCycle, b: AnnualReviewCycle) => {
      return a.name?.trim().localeCompare(b.name?.trim());
    },
    render: (data) => <CycleName id={data.id} name={data.name} />,
  },
  {
    title: 'Review Year',
    dataIndex: '',
    key: 'year',
    render: (data: AnnualReviewCycle) => {
      return <div>{data.year}</div>;
    },
    sorter: (a: AnnualReviewCycle, b: AnnualReviewCycle) => {
      if (a.year && b.year) {
        return dayjs(a.year).diff(dayjs(b.year));
      }
      return 0;
    },
  },
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    key: 'startDate',
    sorter: (a: AnnualReviewCycle, b: AnnualReviewCycle) =>
      dayjs(a.startDate).diff(dayjs(b.startDate)),
    render: (date) => <div>{dayjs(date).format('MMM DD YYYY')}</div>,
  },
  {
    title: 'End Date',
    dataIndex: 'endDate',
    key: 'endDate',
    sorter: (a: AnnualReviewCycle, b: AnnualReviewCycle) =>
      dayjs(a.startDate).diff(dayjs(b.startDate)),
    render: (date) => <div>{dayjs(date).format('MMM DD YYYY')}</div>,
  },
  {
    title: 'Annual Feedback Status',
    dataIndex: 'status',
    key: 'status',
    sorter: (a: AnnualReviewCycle, b: AnnualReviewCycle) => {
      const first = statusArray[Number(a.status)] || a.status;
      const next = statusArray[Number(b.status)] || b.status;
      return first.toString()?.trim().localeCompare(next?.trim());
    },
    render: (status) => <Status status={status} from="quarter" />,
  },
  {
    title: 'Progress',
    dataIndex: 'progress',
    key: 'progress',
    render: (progress, data) => {
      if (progress === 100 && data.status === 1) {
        return (
          <Progress
            percent={progress}
            format={() => <Text>{progress}%</Text>}
            strokeColor={'#1677ff'}
            size="default"
          />
        );
      } else {
        return <Progress percent={progress} size="default" />;
      }
    },
  },
  {
    title: 'Action',
    key: 'action',
    render: (data: AnnualReviewCycle) => {
      return (
        <div className="text-center">
          <Button
            disabled={data.status === 3}
            icon={<EditFilled />}
            onClick={() => onEditClick(data)}
          />
        </div>
      );
    },
  },
];

const CycleName = ({ id, name }: { id: string; name: string }) => {
  const [userState, setUserState] = useAtom(userAtom);
  const navigate = useNavigate();

  const handleClick = () => {
    setUserState({ ...userState, cycleId: id });
    navigate(`${Paths.HRAllAnnualReviews}/${convertNameToPath(name)}`, {
      state: { from: 'hr', selectedId: id },
    });
  };

  return (
    <div onClick={handleClick} className="cursor-pointer hover:text-[#69b1ff]">
      {name}
    </div>
  );
};
